import React from 'react'
import PopUp from '../index'
import birdFace from './../../../assets/images/Bird-face.png'
import crossIcon from './../../../assets/images/cross.png'
import { styles } from '../styles'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'

interface PopupsProps {
  t: TFunction
  open: boolean
  handleClose: any
}

const AddExtensionPopup = ({ t, open, handleClose }: PopupsProps) => {
  const classes = styles()

  return (
    <PopUp
      open={open}
      title={
        <>
          <img
            src={birdFace}
            alt={t('popUps.imageAlts.birdFace')}
            className={classes.imageContainer}
          />
          <div className={classes.textContainer}>
            {t('popUps.text.addExtension')}
          </div>
          <button className={classes.closeButton} onClick={handleClose}>
            <img
              src={crossIcon}
              alt={t('popUps.imageAlts.close')}
              className={classes.closeButton}
            />
          </button>
        </>
      }
      placement="top"
      customStyle={classes.addExtensionPopUpPosition}
    >
      <div></div>
    </PopUp>
  )
}

export default withTranslation()(AddExtensionPopup)
